const siteName = process.env.SITE_TITLE || 'Need Swap Got';

export default (title, section) => {
  if (!section) {
    return `${title} - ${siteName}`;
  }
  return `${title} - ${section} - ${siteName}`;
}
